//
import Pergunta from '../../shared/entity/Pergunta';
import ProdutoNoPedido, { criarProdutoNoPedido } from '../../shared/entity/ProdutoNoPedido';
import Tamanho from '../../shared/entity/Tamanho';
import {
  calcularTotalProduto,
  calcularTotalUnitarioProduto,
  formatarDinheiro,
  setPrecosPromocionaisProduto,
  validarProduto
} from '../../shared/helper';
import { RouteProp } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import React, { useEffect, useState } from 'react';
import { ActivityIndicator, Dimensions, Image, StyleSheet, Text, View } from 'react-native';
import Collapsible from 'react-native-collapsible';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StackParamList } from '../../../App';
import produtoApi from '../../apis/produtoApi';
import colors from '../../colors';
import { TXT_G, TXT_GG, TXT_M } from '../../constants';
import { serialize } from '../../helper';
import { useAlert } from '../../redux/alert/alertHooks';
import {
  usePedido,
  useProdutosCompostosNoPedido,
  useProdutosNoPedido
} from '../../redux/pedido/pedidoHooks';
import Button from '../Generic/Button';
import CTextInput from '../Generic/CTextInput';
import Divider from '../Generic/Divider';
import Header from '../Generic/Header';
import InputQuantidade from '../Generic/InputQuantidade';
import PageContainer from '../Generic/PageContainer';
import ItemPergunta from './ItemPergunta';
import ItemTamanho from './ItemTamanho';
import BotaoPizza from './BotaoPizza';
import ProdutoCompostoNoPedido from '../../shared/entity/ProdutoCompostoNoPedido';

type Props = {
  navigation: StackNavigationProp<StackParamList, 'AdicionarProdutoPage'>;
  route: RouteProp<StackParamList, 'AdicionarProdutoPage'>;
};

const AdicionarProdutoPage: React.FC<Props> = (props) => {
  const { navigation, route } = props;
  const [pedido] = usePedido();
  const id = route.params.id;
  const editIndex = route.params.editIndex; // TS não mostrou, mas pode ser undefined
  const primeiroSabor = route.params.primeiroSabor; // para quando estiver escolhendo o segundo sabor da pizza

  const [urlImagem, setUrlImagem] = useState('');

  const [adicionarProdutoNoPedido, removerProdutoNoPedido, editarProdutoNoPedido] =
    useProdutosNoPedido();
  const [adicionarProdutoCompostoNoPedido, removerProdutoCompostoNoPedido] =
    useProdutosCompostosNoPedido();

  const [mostrarImagem, setMostrarImagem] = useState(false);
  const [produto, setProduto] = useState<null | ProdutoNoPedido>(null);
  const [tamanhos, setTamanhos] = useState<Tamanho[]>([]);
  const [tamanhoSelecionado, setTamanhoSelecionado] = useState(new Tamanho());
  const [perguntas, setPerguntas] = useState<Pergunta[]>([]);
  const [mostrarAlert] = useAlert();

  const [usarPizzaDoisSabores, setUsarPizzaDoisSabores] = useState(false);

  const getProduto = async () => {
    let produto = await produtoApi.getOne({
      where: { id },
      relations: [
        'tamanhos',
        'tamanhos.tamanhoPai',
        'tamanhos.precosPromocionais',
        'tamanhos.precosPromocionais.promocao',
        'cardapios'
      ]
    });
    produto = setPrecosPromocionaisProduto(produto);

    if (editIndex === undefined) {
      // editIndex é se estiver editando algum item do pedido
      const produtoAdicionado = criarProdutoNoPedido(produto);
      const tamanhosSorted = produto.tamanhos.sort((a, b) => a.preco - b.preco);

      if (primeiroSabor) {
        const tamanhoPrimeiroSabor = tamanhosSorted.find(
          (item) => item.descricao === primeiroSabor.tamanhoSelecionado.descricao
        );
        produtoAdicionado.tamanhoSelecionado = tamanhoPrimeiroSabor;
        setTamanhoSelecionado(tamanhoPrimeiroSabor);
      } else {
        produtoAdicionado.tamanhoSelecionado = tamanhosSorted[0];
        setTamanhoSelecionado(tamanhosSorted[0]);
      }

      setTamanhos(tamanhosSorted);
      setPerguntas(produto.perguntas);
      setProduto({ ...produtoAdicionado });
    } else {
      if (pedido && pedido.produtosNoPedido.length > editIndex) {
        const produtoAdicionado = serialize<ProdutoNoPedido>({
          ...pedido.produtosNoPedido[editIndex]
        });
        setTamanhos(produto.tamanhos.sort((a, b) => a.preco - b.preco));
        const tamanho = produto.tamanhos.find(
          (tam) =>
            tam.preco === produtoAdicionado.tamanhoSelecionado.preco &&
            tam.descricao === produtoAdicionado.tamanhoSelecionado.descricao
        );
        if (tamanho) {
          setTamanhoSelecionado(tamanho);
        }
        setPerguntas(produto.perguntas);
        setProduto({ ...produtoAdicionado });
      }
    }
  };

  const verificarImagem = async () => {
    console.log('VERIFICAR IMAGEM');

    const temImagem = await produtoApi.verificarImagem(id);
    setMostrarImagem(temImagem);
    setUrlImagem(produtoApi.getUrlImagem(id));
  };

  useEffect(() => {
    verificarImagem();
  }, [produto?.id]);

  useEffect(() => {
    getProduto();
  }, [id]);

  if (!produto) {
    return (
      <SafeAreaView style={[{ flex: 1, backgroundColor: '#fff', justifyContent: 'center' }]}>
        <ActivityIndicator size={100} color={colors.primary} />
      </SafeAreaView>
    );
  }

  const quantidade = produto ? produto.quantidadeNoPedido : 0;
  const setQuantidade = (novaQuantidade) => {
    const novoProduto = { ...produto };
    novoProduto.quantidadeNoPedido = novaQuantidade;
    setProduto(novoProduto);
  };

  const adicionarOuAtualizar = () => {
    try {
      validarProduto(produto);
      if (editIndex === undefined) {
        adicionarProdutoNoPedido(produto);
      } else {
        editarProdutoNoPedido(editIndex, produto);
      }
      navigation.goBack();
    } catch (err) {
      mostrarAlert('Ops', err.message ?? 'Erro ao salvar produto.');
      console.log(err);
    }
  };

  const adicionarOuSelecionarSegundoSabor = () => {
    console.log('primeiroSabor', primeiroSabor);
    console.log('produto', produto);
    if (!primeiroSabor) {
      setPerguntas([]);
      setProduto(null);
      navigation.navigate('ListaSegundoSaborPage', { primeiroSabor: produto });
      return;
    } else {
      adicionarProdutoCompostoNoPedido({
        produtos: [primeiroSabor, produto]
      } as ProdutoCompostoNoPedido);
      navigation.goBack();
    }

    // TODO acho que aqui precisa continuar
  };

  const selecionarTamanho = (tamanho: Tamanho) => {
    setTamanhoSelecionado(tamanho);
    produto.tamanhoSelecionado = tamanho;
    produto.tamanhoSelecionado.precoPromocional = tamanho.precoPromocional;
    setProduto(produto);
  };

  return (
    <PageContainer header={<Header titulo={produto.nome} goBack />}>
      <View style={styles.content}>
        <Collapsible collapsed={!mostrarImagem}>
          <Image
            onError={() => setMostrarImagem(false)}
            source={{
              uri: urlImagem
            }}
            style={styles.imagem}
          />
        </Collapsible>

        {produto.descricao !== '' && (
          <View>
            <Text style={styles.titulo}>O que é?</Text>
            <Text style={styles.descricao}>{produto.descricao}</Text>

            <Divider style={{ marginBottom: 10, marginTop: 10 }} />
          </View>
        )}

        {
          // !primeiroSabor && produto.permitePizzaDoisSabores && (
          //   <View>
          //     <Text style={styles.titulo}>Quantos sabores?</Text>
          //     <BotaoPizza
          //       usarPizzaDoisSabores={usarPizzaDoisSabores}
          //       setUsarPizzaDoisSabores={setUsarPizzaDoisSabores}
          //     />
          //     <Divider style={{ marginBottom: 10, marginTop: 10 }} />
          //   </View>
          // )
        }

        {Boolean(!primeiroSabor && tamanhos) && (
          <View>
            <Text style={styles.titulo}>Qual tamanho?*</Text>

            {tamanhos.map((tamanho, index) => (
              <ItemTamanho
                tamanho={tamanho}
                key={tamanho.id}
                onPress={selecionarTamanho}
                selecionado={tamanhoSelecionado.id === tamanho.id}
              />
            ))}

            <Divider style={{ marginBottom: 10, marginTop: 10 }} />
          </View>
        )}

        {perguntas.map((pergunta, index) => (
          <ItemPergunta
            key={'pergunta' + index}
            pergunta={pergunta}
            perguntaNoPedido={produto.perguntasNoPedido[index]}
            setPerguntaNoPedido={(pergunta) => {
              produto.perguntasNoPedido[index] = pergunta;
              setProduto({ ...produto });
            }}
          />
        ))}

        <View style={{ marginBottom: 15 }}>
          <View style={{ flexDirection: 'row', alignSelf: 'center', marginBottom: 15 }}>
            <Text style={{ fontSize: TXT_M }}>Valor unitário: </Text>
            <Text style={{ fontSize: TXT_M, color: colors.values }}>
              R$ {formatarDinheiro(calcularTotalUnitarioProduto(produto))}
            </Text>
          </View>

          <InputQuantidade quantidade={quantidade} setQuantidade={setQuantidade} minimo={1} />
        </View>

        {/* <Title style={{ marginBottom: 10 }}>Observação:</Title> */}
        <CTextInput
          label="Observação"
          placeholder={'Exemplo: Sem salada'}
          onChangeText={(txt) => setProduto({ ...produto, observacao: txt })}
          value={produto.observacao}
          style={{ marginBottom: 15 }}
        />

        {usarPizzaDoisSabores ? (
          <Button
            onPress={adicionarOuSelecionarSegundoSabor}
            title={primeiroSabor ? 'ADICIONAR AO PEDIDO' : 'SELECIONAR SEGUNDO SABOR'}
          />
        ) : (
          <Button
            onPress={adicionarOuAtualizar}
            title={
              editIndex !== undefined
                ? `ATUALIZAR NO PEDIDO (R$${formatarDinheiro(calcularTotalProduto(produto))})`
                : `ADICIONAR AO PEDIDO (R$${formatarDinheiro(calcularTotalProduto(produto))})`
            }
          />
        )}
      </View>
    </PageContainer>
  );
};

const DEVICE_WIDTH = Dimensions.get('window').width;
const styles = StyleSheet.create({
  container: {
    // flex: 1,
    // flexGrow: 1,
    backgroundColor: '#fff',
    alignItems: 'center'
  },
  content: {
    // paddingLeft: SIDE_PADDING,
    // paddingRight: SIDE_PADDING,
    // paddingTop: TOP_PADDING,
    backgroundColor: '#fff',
    justifyContent: 'center'
    // alignItems: 'center'
  },
  imagem: {
    width: '100%',
    height: 250,
    resizeMode: 'cover',
    borderRadius: 7,
    marginBottom: 10
    // alignSelf: 'center'
  },
  titulo: {
    fontSize: TXT_GG,
    fontWeight: '700',
    marginBottom: 10
    // color: colors.darkGrey
  },
  descricao: {
    fontSize: TXT_M,
    marginBottom: 20
  },
  preco: {
    marginBottom: 20,
    alignSelf: 'center',
    fontWeight: '700',
    fontSize: TXT_G
  }
});

export default AdicionarProdutoPage;
